import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { initSentry } from './sentry.ts';
initSentry();

import '@stripe/stripe-js';

import { store } from './app/store';
import App from './App.tsx';
import './index.css';
import { GracefulUnmount } from './components/GracefulUnmount.tsx';
import { startOutputBroadcast } from './app/modules/output/middleware.ts';


const unsubscribe = startOutputBroadcast(store);

window.addEventListener('beforeunload', unsubscribe);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GracefulUnmount>
      <Provider store={store}>
        <App />
      </Provider>
    </GracefulUnmount>
  </StrictMode>,
);
